export const GBR_EMAIL = "gbrtt.co.uk";
export const NETWORK_RAIL_EMAIL = "networkrail.co.uk";
